var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1Thq6KUwRhU6Tu3K5KtCc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["public-action-centers@muster"]={id:"1Thq6KUwRhU6Tu3K5KtCc"};
      